module.exports = __webpack_public_path__ + "static/media/logo.7393eaf0.png";